import React from 'react';

import styled from '@emotion/styled';
import { Site } from '@vromo/models';
import Input from '@vromo/ui/components/Input';
import { observer } from 'mobx-react-lite';
import { action } from 'mobx';
import Alert from '@vromo/ui/components/Alert';
import { qaLabelTestSites } from './../../../../../../common-qa-labels/sites';
const FilterRow = styled.div`
    display: flex;
    flex-direction: column;
    padding: 5px 0px;

    label {
        flex: 1;
    }

    input,
    select {
        margin-top: 5px;
    }
`;

type Props = {
    editedSite: Site;
    isNew: boolean;
};

export default observer(function EditAdvanced({ editedSite, isNew }: Props) {
    return (
        <>
            {isNew ? null : (
                <FilterRow style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                        <label>ID</label>
                        <p data-testid={qaLabelTestSites.editSiteModal.id} style={{ margin: 0 }}>{editedSite.id}</p>
                    </div>
                </FilterRow>
            )}
            <FilterRow>
                {isNew ? (
                    <>
                        <Input
                            label="External ID"
                            data-testid={qaLabelTestSites.addSiteModal.externalIdInput}
                            optional
                            value={editedSite.external || ''}
                            onChange={action((e) => {
                                editedSite.external = e.target.value;
                            })}
                        />
                        {editedSite.external && /[./\s]/.test(editedSite.external) ? (
                            <Alert
                                warning
                                style={{ maxWidth: 520 }}
                                data-test-id="external-id-warning">
                                External IDs containing the special characters <strong>.</strong>
                                {'  '}
                                <strong>/</strong>
                                {'  '}or whitespace characters can cause issues when referencing
                                sites by their external ID in a URL. If you plan on accessing sites
                                this way, you'll need to remove these characters.
                            </Alert>
                        ) : null}
                    </>
                ) : (
                    editedSite.external && (
                        <>
                            <label>External ID</label>
                            <div data-testid={qaLabelTestSites.editSiteModal.externalId}>{editedSite.external}</div>
                        </>
                    )
                )}
            </FilterRow>
        </>
    );
});
